<div class="app-navigation-card {{ searchControlService.isNavigationCollapsed ? 'collapsed' : 'expanded' }}" [@slideAnimation]="searchControlService.isNavigationCollapsed ? 'collapsed' : 'expanded'">
  <button class="collapse-button" (click)="togglePanel()">
    <mat-icon>{{ searchControlService.isNavigationCollapsed ? 'arrow_right' : 'arrow_left' }}</mat-icon>
  </button>

  <div class="navigation-content-container">
    <ngx-simplebar [options]="{ autoHide: true }" style="height: 100%">
      <mat-toolbar>
        <button mat-icon-button aria-label="Back button" (click)="goBack()">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <span>Navigation</span>
      </mat-toolbar>

      <div class="navigation-content">
        <div class="loading-container" *ngIf="isLoading()">
          <mat-spinner diameter="40" class="loading-spinner"></mat-spinner>
        </div>

        <div class="error-message" *ngIf="errorMessage" style="margin-bottom: 1rem">
          <mat-icon>error</mat-icon>
          <p>{{ errorMessage }}</p>
        </div>

        <form
          class="location-form"
          cdkDropList
          [cdkDropListData]="waypoints()"
          (cdkDropListDropped)="drop($event)"
        >
          @for (waypoint of waypoints(); track waypoint) {
            <div class="location-item" cdkDrag [cdkDragData]="waypoint">
              <mat-form-field appearance="outline">
                <button mat-icon-button cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
                </button>

                <input
                  matInput
                  [value]="waypoint.name"
                  (input)="updateWaypoint($index, $event)"
                  [matAutocomplete]="auto"
                  #autoFocus
                  [style.color]="waypoint.name === 'Your location' ? '#0097e9' : ''"
                  (click)="clearWaypoint($index, $event)"
                />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  (optionSelected)="addressSelected($index, $event.option._getHostElement().dataset)"
                  class="search-autocomplete"
                >
                  <mat-option
                    *ngFor="let option of waypoint.searchResults"
                    [attr.data-value]="convertJSON(option)"
                    [value]="option.address.formattedAddress"
                  >
                    <div class="search-option-wrapper">
                      {{ option.address.formattedAddress }}
                      <mat-icon style="margin-right:0" *ngIf="option.isStation" svgIcon="gc_station"></mat-icon>
                    </div>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <button *ngIf="$first" mat-icon-button (click)="addWaypoint()">
                <mat-icon>add</mat-icon>
              </button>
              <button
                *ngIf="!$first && waypoints().length > 2"
                mat-icon-button
                (click)="removeWaypoint($index)"
              >
                <mat-icon>close</mat-icon>
              </button>
              <span
                *ngIf="!$first && waypoints().length <= 2"
                style="display: block; width: 40px; height: 40px; flex-shrink: 0;"
              >
              </span>
            </div>

            <div class="location-item" cdkDrag [cdkDragData]="waypoint" *ngFor="let station of waypoint?.stations">
              <mat-form-field appearance="outline">
                <button mat-icon-button cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
                </button>

                <input
                  matInput
                  [value]="station.name"
                  [matAutocomplete]="auto"
                  disabled
                />
              </mat-form-field>

              <button
                mat-icon-button
                (click)="removeWaypointStation($index, station.id)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
        </form>

        <mat-divider></mat-divider>

        <div *ngIf="routeData()" class="route-details">
          <p class="description" *ngIf="routeData()?.description">
            <span style="display: flex;align-items: center;gap: 8px;">
              <mat-icon>directions</mat-icon>
              {{ routeData()?.description }}
            </span>
          </p>
          <div class="description" style="flex-direction: column;gap: 0;" [style.paddingTop]="routeData()?.description ? 0 : '20px'">
            <span class="list-item">
              <mat-icon style="color: red;">directions_car</mat-icon>
              <span style="font-weight: 600;font-size: 21px;">{{ formatDuration(totalEstimatedTimeIncludesDuration) }}</span>
              <span *ngIf="routeData()?.distanceMeters">({{ routeData()?.distanceMeters }})</span>
            </span>
            <span class="list-item distance" *ngIf="isChargerExists()">
              <mat-icon style="color: #fbb818;">bolt</mat-icon>
              <span>
                Includes ~{{ formatDuration(totalEstimatedTime) }} charging time
                <span *ngIf="getStationName()">at {{ getStationName() }}</span>
              </span>
            </span>
          </div>

          <mat-divider></mat-divider>
        </div>

        <!-- Ad Slot A: Between route summary and stepper -->
        <app-ad-native placement="NAVIGATION_ROUTE" *ngIf="routeData()" style="display:block;margin:12px 16px"></app-ad-native>

        <div *ngIf="routeData()" class="waypoint-stepper-container">
          <div class="waypoint-stepper">
            @for (step of getWaypointResults(); track step) {
              <div class="stepper-item" *ngIf="!step.placeId && !step.station && step.latLng">
                <h4 class="name">Your Location</h4>
                <!-- <p class="address">4517 Washington Ave. Manchester, Kentucky 39495</p> -->
                <p class="distance" *ngIf="step.distance || step.duration">
                  <span *ngIf="step.duration">{{ step.duration }}</span> <span *ngIf="step.distance">({{ step.distance }})</span>
                </p>
              </div>

              <div class="stepper-item" *ngIf="step.placeId">
                <h4 class="name">{{ step.name }}</h4>
                <!-- <p class="address">4517 Washington Ave. Manchester, Kentucky 39495</p> -->
                <p class="distance" *ngIf="(step.distance || step.duration) && !$last">
                  <span *ngIf="step.duration">{{ step.duration }}</span> <span *ngIf="step.distance">({{ step.distance }})</span>
                </p>
              </div>

              <a class="stepper-item station" *ngIf="step.station" routerLink="/station/{{ step.station.id }}">
                <h4 class="name">{{ step.station.name }}</h4>
                <p class="address">{{ prettyAddress(step.station.locationAddress, step.station.locationCity, step.station.locationState) }}</p>
                <p class="charge"><mat-icon>bolt</mat-icon> Charge: ~{{ formatDuration(estimatedTime) }}</p>
                <p class="distance" *ngIf="(step.distance || step.duration) && !$last">
                  <span *ngIf="step.duration">{{ step.duration }}</span> <span *ngIf="step.distance">({{ step.distance }})</span>
                </p>
              </a>
            }
          </div>
        </div>

        <!-- Ad Slot B: Banner at bottom of navigation -->
        <app-ad-banner placement="NAVIGATION_BOTTOM" style="display:block;margin:0 16px 16px"></app-ad-banner>
      </div>
    </ngx-simplebar>
  </div>
</div>
